import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Make React and ReactDOM available globally for window components
window.React = React;
window.ReactDOM = ReactDOM;

// Global Email Validation Helper
window.validateEmail = function(email) {
  if (!email || typeof email !== 'string') return false;
  const trimmed = email.trim();
  // Standard RFC 5322 regex validation
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(trimmed)) return false;

  const parts = trimmed.split('@');
  if (parts.length !== 2) return false;
  const domain = parts[1].toLowerCase();

  // Check valid TLD domain
  if (!domain.includes('.')) return false;
  const domainParts = domain.split('.');
  const tld = domainParts[domainParts.length - 1];
  if (!tld || tld.length < 2) return false;

  // Block obvious invalid test domain placeholders
  const blocked = ['example.com', 'test.com', 'invalid.com'];
  if (blocked.includes(domain)) return false;

  return true;
};

// Import API and Data modules
import './admin/apiClient.js';
import './utils/seoHelper.js';

// Import Components
import './components/Header.jsx';
import './components/Footer.jsx';
import './components/QuoteModal.jsx';

// Import Pages
import './pages/HomePage.jsx';

// Import App Root
import './App.jsx';

// Mount Application to #root
const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(React.createElement(window.App));
}
